import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SaveReportDialogData } from "./home.component";
import { RouseService } from "../rouse.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'save-report-dialog',
  templateUrl: 'save-report-dialog.html',
  styleUrls: ['save-report-dialog.css']
})
export class SaveReportDialog implements OnInit {
  recordExists: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<SaveReportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SaveReportDialogData,
    private rouseService: RouseService,
    private toastr: ToastrService) { }

  async ngOnInit(): Promise<void> {

  }
  async onClickSave(): Promise<void> {

    const fileName = this.data.id === 0 ? this.data.filename : this.data.newFilename;
    let newId = this.data.id === 0 ? 0 : this.data.id;
    if (this.data.selectedOption == 2) {
      newId = 0;
    }

    const username = localStorage.getItem('email');
    this.recordExists = await this.rouseService.validateSavedReportData(fileName, newId, username);

    if (!this.recordExists) {
      this.dialogRef.close(this.data);
    } else {
      this.toastr.error('Filename already exists.');
    }
  }
  onClickCancel(): void {
    this.dialogRef.close();
  }
}
